import { Navigate } from "react-router-dom";
import {
  EVENT_COLLECT_PROVIDER_KEY,
  EVENT_COLLECT_TOKEN_KEY,
} from "./utils/constants";

interface Props {
  children: JSX.Element;
}

export const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const user = localStorage.getItem(EVENT_COLLECT_TOKEN_KEY);
  const provider = localStorage.getItem(EVENT_COLLECT_PROVIDER_KEY);
  if (!user || provider === "azure-sso") {
    return <Navigate to="/" />;
  }
  return children;
};
